import React, {Component} from 'react';
import AuthService from '../../services/authService';
import {Link} from 'react-router-dom';
import '../Register/register.scss';
import logo from "../../assets/images/happily-ever-after_m365_WHITE.png";
import axios from 'axios';

class ForgotPassword extends Component {

    constructor() {
        super();
    }

    componentWillMount() {
        if (AuthService.loggedIn())
            this.props.history.replace('/welcome');
    }

    getFormData(event) {
        event.preventDefault();

        let email = document.getElementById("forgot-password").value;

        let passwordObj = {
            email,
        };
        this.sendData(passwordObj);
    }

    async sendData(registerObj) {
        let dataURL = "https://onamfc.com/api/recover-password";
        await axios.post(dataURL, registerObj).then(res => {
            // Do this after receiving the response
            let greeting = document.getElementById('page-heading');
            greeting.innerText = "Please check your email for a link to reset your password";
            greeting.style.color = 'red';
        }).catch(() => {
            let greeting = document.getElementById('page-heading');
            greeting.innerText = "Sorry, we weren't able to find that email";
            greeting.style.color = 'red';
        });
    }


    render() {
        return (
            <div id="login-page">
                <div className="container">
                    <div className="image-container">
                        <img src={logo} alt="Happily Ever After Logo"/>
                    </div>
                    <div id="login-form-container" className="forgot">
                        <div className="title">Already a Member? <Link to="/login">Log in here</Link></div>
                        <h3 id="page-heading">Forgot your Password?</h3>
                        <div id="password-form">
                            <form onSubmit={this.getFormData.bind(this)}>
                                <div className="form__field">
                                    <label>Email Address</label>
                                    <input id="forgot-password" type="text" name="email"/>
                                </div>


                                <button type="submit" className="yellow-btn">Reset Password</button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>

        )

    }


}

export default ForgotPassword;
